import { IStore } from '..';
import { TFileStatus } from '../../app/types/outbound-campaign-manager-types';

export const getFileStatusList = (state: IStore): TFileStatus[] =>
  state.fileStatusReducer.statusList;
  